// extracted by mini-css-extract-plugin
export default {"checkbox":"AbstractProductEditStep3_checkbox__+QEda"};